var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTether(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48561 5.08765H17.7151C17.983 5.08765 18.2306 5.23043 18.3642 5.46208L21.6358 11.1335C21.8055 11.4276 21.7551 11.7988 21.5131 12.0373L12.5079 20.9124C12.2162 21.1998 11.7469 21.1998 11.4552 20.9124L2.46216 12.0493C2.21454 11.8053 2.16817 11.4232 2.35026 11.1273L5.84737 5.44389C5.98354 5.22255 6.22523 5.08765 6.48561 5.08765ZM16.2652 7.61973V9.21103H13.0664V10.3143C15.313 10.4322 16.9986 10.9165 17.0111 11.4969L17.011 12.7069C16.9985 13.2874 15.313 13.7716 13.0664 13.8895V16.5971H10.9423V13.8895C8.69562 13.7716 7.01007 13.2873 6.99754 12.7069L6.99762 11.4969C7.01012 10.9165 8.69562 10.4322 10.9423 10.3143V9.21103H7.74345V7.61973H16.2652ZM12.0043 13.0582C14.4019 13.0582 16.4058 12.6487 16.8963 12.1019C16.4804 11.6382 14.9761 11.2733 13.0664 11.1731V12.3282C12.7241 12.3462 12.3687 12.3556 12.0043 12.3556C11.6399 12.3556 11.2846 12.3462 10.9423 12.3282V11.1731C9.03251 11.2733 7.52822 11.6382 7.11234 12.1019C7.6028 12.6487 9.60674 13.0582 12.0043 13.0582Z",
    fill: "#009393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTether);
export default __webpack_public_path__ + "static/media/tether.c517903108a66cb5a046e007ee6d0e5f.svg";
export { ForwardRef as ReactComponent };